export interface V2TimConversationOperationResult {
    conversationID?: String;
    resultCode?: number;
    resultInfo?: String;
}
